import React from 'react';
export type MenuCategory = 'kebabs' | 'papas' | 'extras' | 'bebidas';
export const MENU_TABS: {
  id: MenuCategory;
  label: string;
}[] = [{
  id: 'kebabs',
  label: 'KEBABS'
}, {
  id: 'papas',
  label: 'PAPAS'
}, {
  id: 'extras',
  label: 'EXTRAS'
}, {
  id: 'bebidas',
  label: 'BEBIDAS'
}];
interface MenuNavProps {
  active: MenuCategory;
  onChange: (id: MenuCategory) => void;
}
export function MenuNav({
  active,
  onChange
}: MenuNavProps) {
  return <nav className="sticky top-0 z-[100] w-full bg-bp-bg2" style={{
    borderBottom: '1px solid rgba(242, 235, 221, 0.15)'
  }} aria-label="Navegación del menú" data-id="element-100">
      <div className="max-w-container mx-auto w-full flex items-center justify-between md:justify-center px-2 md:gap-12" data-id="element-101">
        {MENU_TABS.map(tab => {
        const isActive = active === tab.id;
        return <button key={tab.id} onClick={() => onChange(tab.id)} aria-current={isActive ? 'true' : undefined} className="font-display text-bp-text text-base sm:text-lg md:text-2xl tracking-[0.08em] md:tracking-[0.15em] uppercase whitespace-nowrap px-2 sm:px-3 md:px-6 py-5 transition-opacity duration-300" style={{
          opacity: isActive ? 1 : 0.4
        }} data-id="element-102">
              {tab.label}
            </button>;
      })}
      </div>
    </nav>;
}